<h3>Roles and Permission</h3>

<table class="table">
	<thead>
		<tr>
			<th>&nbsp;</th>
			<th>&nbsp;</th>
			<th *ngFor="let appRole of appRoles" class="text-center">
				{{appRole.name}}
			</th>
		</tr>
	</thead>
	<tbody>
		<tr class="table-dark">
			<td [colSpan]="2">Agent Permissions</td>
			<td *ngFor="let appRole of appRoles"
				[nzChecked]="areAllSelected(agentPermissions, appRole.id)"
				[nzIndeterminate]="areSomeSelected(agentPermissions, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(agentPermissions, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of agentPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td [colSpan]="2">Member Permissions</td>
			<td *ngFor="let appRole of appRoles"
				[nzChecked]="areAllSelected(memberPermissions, appRole.id)"
				[nzIndeterminate]="areSomeSelected(memberPermissions, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(memberPermissions, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of memberPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td [colSpan]="2">Ticket Permissions</td>
			<td *ngFor="let appRole of appRoles"
				[nzChecked]="areAllSelected(ticketPermissions, appRole.id)"
				[nzIndeterminate]="areSomeSelected(ticketPermissions, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(ticketPermissions, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of ticketPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td [colSpan]="2">Communication Permissions</td>
			<td *ngFor="let appRole of appRoles"
				[nzChecked]="areAllSelected(communicationPermissions, appRole.id)"
				[nzIndeterminate]="areSomeSelected(communicationPermissions, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(communicationPermissions, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of communicationPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>

		<tr class="table-dark">
			<td [colSpan]="2">Entity Permissions</td>
			<td *ngFor="let appRole of appRoles"
				[nzChecked]="areAllSelected(entityPermissions, appRole.id)"
				[nzIndeterminate]="areSomeSelected(entityPermissions, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(entityPermissions, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of entityPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>


		<tr class="table-dark">
			<td [colSpan]="2">Configuration Properties</td>
			<td *ngFor="let appRole of appRoles"
				[nzChecked]="areAllSelected(configurationPermissions, appRole.id)"
				[nzIndeterminate]="areSomeSelected(configurationPermissions, appRole.id)"
				(nzCheckedChange)="setMultipleSelected(configurationPermissions, appRole.id, $event)">
			</td>
		</tr>
		<tr *ngFor="let permission of configurationPermissions; trackBy: trackByPermission">
			<td>{{permission.label}}</td>
			<td>{{permission.description}}</td>
			<td *ngFor="let role of permission.roles; trackBy: trackByRole" class="text-center">
				<input type="checkbox" style="transform: scale(1.5);" [(ngModel)]="role.selected" name="permission_{{permission.permission}}_{{role.roleId}}"/>
			</td>
		</tr>
	</tbody>
</table>
<div class="row" *hasPermission="['PermissionManage']">
	<div class="col">
		<button class="btn btn-success float-end" (click)="doSubmit()">Save</button>
	</div>
</div>
